import { validateLength } from "./length.validate";
import { showErrors, showErrorsByNames, hideErrors, showCommonErrors } from "./errors.handle";
import { validateFormByRules } from "./rules.validate";

const validateForm = (form, validationRules, config) => {
    let errors = validateFormByRules(form, validationRules, config);
    return errors;
}


export { validateLength, validateForm, showErrors, hideErrors, showErrorsByNames, showCommonErrors };